import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: '',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/public/LoginView.vue"),
    },

    // ADMIN
    {
        path: '/admin-sistem',
        name: 'AdminSistem',
        component: () => import('../views/admin/setting/UserView.vue')
    },
    {
        path: '/admin-struktur-organisasi-sistem',
        name: 'AdminStrukturSistem',
        component: () => import('../views/admin/setting/StrukturSistemView.vue')
    },
    {
        path: '/admin-setting',
        name: 'AdminSetting',
        component: () => import('../views/admin/setting/SettingView.vue')
    },
    {
        path: '/cust-region',
        name: 'AdminWilayah',
        component: () => import('../views/admin/mitra/WilayahView.vue')
    },
    {
        path: '/customer',
        name: 'AdminCustomer',
        component: () => import('../views/admin/mitra/CustomerView.vue')
    },
    {
        path: '/product-sales-brand',
        name: 'AdminSalesBrand',
        component: () => import('../views/admin/product/SalesBrandView.vue')
    },
    {
        path: '/product-ar-payment',
        name: 'AdminProductTax',
        component: () => import('../views/admin/product/TaxView.vue')
    },
    {
        path: '/cust-category',
        name: 'AdminCustCategory',
        component: () => import('../views/admin/mitra/KategoriView.vue')
    },
    {
        path: '/product-category',
        name: 'AdminProductGroup',
        component: () => import('../views/admin/product/MaterialGroupView.vue')
    },
    {
        path: '/pegawai',
        name: 'AdminPegawai',
        component: () => import('../views/admin/sales/SalesmanView.vue')
    },
    {
        path: '/supplier',
        name: 'AdminVendor',
        component: () => import('../views/admin/mitra/VendorView.vue')
    },
    {
        path: '/product',
        name: 'AdminProduct',
        component: () => import('../views/admin/product/MaterialView.vue')
    },
    {
        path: '/warehouse',
        name: 'AdminWarehouse',
        component: () => import('../views/admin/inventory/WarehouseView.vue')
    },
    {
        path: '/mobile-order-entry',
        name: 'AdminMobileOrder',
        component: () => import('../views/admin/cloud-mobile/CloudMobileView.vue')
    },
    {
        path: '/export-cloud-sales-order',
        name: 'ExportCloudSalesOrder',
        component: () => import('../views/admin/cloud-mobile/ExportOrderView.vue')
    },
    {
        path: '/sales-invoice',
        name: 'AdminSalesInvoice',
        component: () => import('../views/admin/sales/OrderInvoiceView.vue')
    },
    {
        path: '/saldo-stock',
        name: 'AdminSaldoStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/warning-stock',
        name: 'AdminWarningStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/umur-stock',
        name: 'AdminUmurStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/tax-keluaran',
        name: 'AdminTaxKeluaran',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/sales-delivery',
        name: 'AdminSalesDelivery',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/export-sales-detil',
        name: 'ExportSalesDetil',
        component: () => import('../views/admin/sales/ExportSalesDetilView.vue')
    },
    {
        path: '/sales-summary-product',
        name: 'AdminSalesSummaryProduct',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/log-exim',
        name: 'AdminLogExim',
        component: () => import('../views/admin/cloud-mobile/LogEximView.vue')
    },
    {
        path: '/dashboard-utama',
        name: 'AdminDashboardUtama',
        component: () => import('../views/admin/utils/DashboardView.vue')
    },

    {
        path: '/analisis-ldh-cash-analisis',
        name: 'LdhCashAnalisisView',
        component: () => import('../views/admin/distributor-analisis/LdhCashAnalisisView.vue')
    },

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;